module.exports = {
  "country": "DE",
  "artist": "Isaak",
  "song": "Always on the Run",
  "year": "2024",
  "place": "12",
  "spotify": "749xLlYIFF0zPix9clGbQz"
};